export default __webpack_public_path__ + "static/media/blog7.7f6ab0e8.png";